import Model from "./model";
import RelationContact from "./relation-contact.model";
import Invoice from "./invoice.model";
import Subscription from "./subscription.model";
import {Ticket} from "./ticket.model";
import {RelationInvoiceType} from "../enums/relation-invoice-type";
import {RelationInvoicePeriod} from "../enums/relation-invoice-period";
import CommunicationPreferences from "./communication-preferences.model";

export default class Relation extends Model {
  public full_name: string = '';
  public name: string = '';
  public customer_id: string = '';
  public housenumber: string = '';
  public housenumberext: string = '';
  public street: string = '';
  public city: string = '';
  public zipcode: string = '';
  public bank_account: string = '';
  public is_business: boolean = false;
  public coc_number: string = '';
  public postal_street: string = '';
  public postal_zipcode: string = '';
  public postal_housenumber: string = '';
  public postal_housenumberext: string = '';
  public postal_city: string = '';
  public vat_reverse_charge: boolean = false;
  public vat_number: string = '';
  public bic_number: string = '';
  public invoice_type: RelationInvoiceType = RelationInvoiceType.INVOICE;
  public invoice_period: RelationInvoicePeriod = RelationInvoicePeriod.QUARTERLY;
  public invoice_date: string = '';
  public digital_fact: boolean = false;
  public fact_collective_invoice: boolean = false;

  public relation_contacts: RelationContact[] = [];
  public tickets: Ticket[] = [];
  public invoices: Invoice[] = [];
  public subscriptions: Subscription[] = [];
  public communication_preferences: CommunicationPreferences = new CommunicationPreferences()
}
